export default "__VITE_ASSET___app/immutable/assets/logotype-docs._cZdhNtZ.svg__"